"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NO_POLYGLOT_CONTEXT = void 0;
exports.NO_POLYGLOT_CONTEXT = [
    'Warning:',
    't is called without Polyglot context.',
    'Perhaps you need to wrap the component in <I18n>?',
].join(' ');
